<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: any,
}
const props = defineProps<Props>()
const oldWards = computed(() => {
  return props?.data?.ward?.old?.length > 0 ? props.data?.ward?.old?.map((item: any) => {
    return item.old_ward_name
  }): []
})
</script>

<template>
  <span class="name">
<!--    {{props}}-->
    <strong>{{props.data?.province?.name}} - {{props.data?.ward?.name}}</strong><br/>
    <span style="color: #ababab">{{oldWards.join(', ')}}</span>
  </span>
</template>

<style scoped>

</style>
